import { HttpClient } from '@angular/common/http'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { EMPTY, empty, EmptyError, Observable, of, Subject, Subscription } from 'rxjs'
import { debounceTime, switchMap, retry, tap, take, mergeMap, catchError } from 'rxjs/operators'
import { AppConfigService } from '../../../app-config/app-config.service'
import { ServerInfo } from '../../../models/app-config/server-info.model'
import { Router } from '@angular/router'

@Component({
  selector: 'jml-lib-connection-failed',
  templateUrl: './connection-failed.component.html',
  styleUrls: ['./connection-failed.component.scss']
})
export class ConnectionFailedComponent implements OnInit, OnDestroy {
  baseUrl: string
  urlIsValid = false
  $urlInput = new Subject()

  subscriptions: Subscription[] = []

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.baseUrl = AppConfigService.getBaseUrl()

    this.subscriptions.push(
      this.appConfig
        .getBaseUrl$()
        .pipe(
          tap((baseUrl) => {
            this.baseUrl = baseUrl

            // for cases where the url is valid..
            this.$urlInput.next(this.baseUrl)
          })
        )
        .subscribe()
    )

    this.subscriptions.push(
      this.$urlInput
        .asObservable()
        .pipe(
          tap(() => (this.urlIsValid = false)),
          debounceTime(400),
          switchMap((baseUrl) => {
            console.log('attempting: ' + baseUrl)
            return this.http.get<ServerInfo>(baseUrl + '/admin/info').pipe(
              catchError((error) => {
                console.log(error)
                return EMPTY
              }) // this construction keeps the outer observable in the game even if the inner completes
              // otherwise the subscription would get the error and the subject would end.
            )
          })
        )
        .subscribe(() => {
          this.urlIsValid = true
        })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }

  setUrl() {
    this.appConfig.overwriteBaseUrl(this.baseUrl)
    this.router.navigate(['/'])
  }

  onInput() {
    this.$urlInput.next(this.baseUrl)
  }
}
